<template>
    <FooterBottom class="mx-w-1200 w-984 m-auto"/>
</template>

<script>
import FooterBottom from './FooterBottom.vue'
export default {
    name: 'FooterWrapper',
    components: {
        FooterBottom
    }
}
</script>

<style>

</style>